import React, { useState, useEffect, useMemo, useCallback } from "react";
import { Accordion, Row, Col } from "react-bootstrap"; // Added Tabs, Tab, and Button components
import { useLocation } from "react-router-dom";
import TopNav from "../../TopNav/TopNav";
import JobNav from "../JobNav";
import JobGeneralOverview from "../JobOverviewBar";
import { useSelector } from "react-redux";
import { selectUserDetails } from "../../../redux/slices/userSlice";
import CheckoutNotification from "../checkoutNotification";
import useJobHandler, { useJobSync } from "../../../functions/JobHandler";

import SoldToShipTo from "./SoldToShipTo";
import PriceBreakdown from "./PriceBreakdown";
import OwnersManual from "./OwnersManual";
import SalesComments from "./SalesComments";
import PSNCopyButton from "./PSNCopyButton"

function JobSalesInfo() {
  // Fetch the current user from the Redux store
  const currentKey = "salesInfo";
  const userDetails = useSelector(selectUserDetails); // User details
  const currentUser = userDetails?.name;

  // Fetch Job Details from Redux
  const jobId = useSelector((state) => state.jobId.jobId); // Fetch jobId from redux
  const tbdForms = useSelector((state) => state.tbd?.forms || {});
  //const tableIds = useSelector((state) => state.tables.tableIds); // Fetch tableIds from redux

  useJobHandler(); // Call the useJobHandler function
  
  // Sync job data when this page loads
  const { syncJob } = useJobSync();
  
  useEffect(() => {
    if (jobId) {
      console.log("JobSalesInfo: Syncing job data for jobId:", jobId);
      syncJob({ reuseRecent: true })
        .then((result) => {
          if (result && result.fieldsUpdated > 0) {
            console.log(`JobSalesInfo: Updated ${result.fieldsUpdated} fields across ${result.sectionsUpdated} sections`);
          } else {
            console.log("JobSalesInfo: Job data is already up to date");
          }
        })
        .catch((error) => {
          console.error("JobSalesInfo: Failed to sync job data:", error);
        });
    }
  }, [jobId, syncJob]);

    // useEffect(() => {
    //   dispatch(clearApiStatus());
    // }, [dispatch]);

  const location = useLocation();
  const { state } = location;
  const tbdItem = state?.tbdItem;

  const [, setAccordionToggles] = useState({});

  const sections = useMemo(
    () => [
      {
        name: "Sold To/ Ship To",
        component: SoldToShipTo,
      },
      {
        name: "Price Breakdown",
        component: PriceBreakdown,
      },
      {
        name: "Owners Manual Requirements",
        component: OwnersManual,
      },
    ],
    []
  );

  // useEffect(() => {
  //   if (jobId) {
  //     dispatch((dispatch, getState) => fetchMissingJobDetails(dispatch, getState, jobId));
  //   }
  // }, [jobId, dispatch]);


  // useEffect(() => {
  //   if (jobId) {
  //     // Define the specific API URLs you want to check
  //     const selectedApiUrls = {
  //       generalProject: apiUrls.generalProject,
  //       soldToShipTo: apiUrls.soldToShipTo,
  //       priceBreakdown: apiUrls.priceBreakdown,
  //       ownersManual: apiUrls.ownersManual,
  //     };
  //     dispatch(
  //       fetchJobDetails({
  //         jobId,
  //         apiUrls: selectedApiUrls,
  //       })
  //     );
  //   }
  // }, [jobId, dispatch, apiUrls]);

  const expandAccordion = useCallback((tbdItem) => {
    // Implement the logic to expand the accordion
    const sectionName = tbdItem.Table;
    const sectionIndex = sections.findIndex(section => section.name.toLowerCase() === sectionName.toLowerCase());
    if (sectionIndex !== -1) {
      setAccordionToggles(prevToggles => ({
        ...prevToggles,
        [sections[sectionIndex].name]: "yes"
      }));
    }
  }, [sections]);

  useEffect(() => {
    if (tbdItem) {
      // Logic to expand the corresponding accordion based on tbdItem
      expandAccordion(tbdItem);
    }
  }, [tbdItem, expandAccordion]);

  const hasTbdForSection = (section) => {
    if (section === "SoldToShipTo") {
      return Boolean(tbdForms.soldToShipTo?.hasTbd);
    }

    if (section === "Price Breakdown") {
      return Boolean(tbdForms.priceBreakdown?.hasTbd);
    }

    if (section === "Owners Manual Requirements") {
      return Boolean(tbdForms.ownersManual?.hasTbd);
    }

    return false;
  };

  return (
    <div>
      <TopNav />
      <JobGeneralOverview />
      <JobNav keyValue={currentKey} />
      <CheckoutNotification currentUser={currentUser} />
      <Accordion alwaysOpen>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <h3>
              {hasTbdForSection("SoldToShipTo") && (
                <i
                  className="bi bi-exclamation-diamond-fill"
                  style={{ color: "red" }}
                />
              )}{" "}
              Sold To/ Ship To
            </h3>
          </Accordion.Header>
          <Accordion.Body>
            <SoldToShipTo />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <h3>
              {hasTbdForSection("Price Breakdown") && (
                <i
                  className="bi bi-exclamation-diamond-fill"
                  style={{ color: "red" }}
                />
              )}{" "}
              Price Breakdown
            </h3>
          </Accordion.Header>
          <Accordion.Body>
            <PriceBreakdown />
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <h3>
              {hasTbdForSection("Owners Manual Requirements") && (
                <i
                  className="bi bi-exclamation-diamond-fill"
                  style={{ color: "red" }}
                />
              )}{" "}
              Owners Manual Requirements
            </h3>
          </Accordion.Header>
          <Accordion.Body>
            <OwnersManual />
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      <Row className="m-3">
        <Col>
          <SalesComments />
        </Col>
      </Row>
      <PSNCopyButton />
    </div>
  );
}

export default JobSalesInfo;
